import { createSelector } from 'reselect';

import WorkspaceRecentUpdatesConstants from '../constants/WorkspaceRecentUpdates.constants';

// TODO (josh) : this key should come from a constant
const getWorkspaceRecentUpdates = State => State.workspaceRecentUpdates;

function createParameterSelector(selector) {
  return (_, params) => selector(params);
}

const getWorkspaceUuidParam = createParameterSelector(params => params.workspaceUuid);

const getAllRecentUpdates = createSelector([getWorkspaceRecentUpdates], recentUpdates => {
  return recentUpdates.get(WorkspaceRecentUpdatesConstants.State.WORKSPACES_RECENT_UPDATES_BY_ID);
});

export const getRecentUpdatesByWorkspaceUuid = createSelector(
  [getAllRecentUpdates, getWorkspaceUuidParam],
  (recentUpdates, workspaceUuid) => {
    return recentUpdates
      .filter(update => update.get(WorkspaceRecentUpdatesConstants.Model.WORKSPACE_SLUG) === workspaceUuid)
      .sortBy(update => update.get(WorkspaceRecentUpdatesConstants.Model.TIME))
      .reverse();
  }
);
